import moment from 'moment'

export const getSubtitleDate = (timeType, date, time = '') => {
  if (timeType === "Week") {
    const weekOfDay = moment(date).format('E');
    const one =  moment(date).subtract(Number(weekOfDay) - 1, 'days').format("YYYY-MM-DD")
    return `${one} ~ ${date}`
  }
  if (timeType === 'Hour') {
    return moment(`${date} ${time}`).format('YYYY-MM-DD HH:mm')
  }

  return timeType === "Month" ? moment(date).format("YYYY-MM") : date
}

export const getEventTypeText = (source, isEn) => {
  return isEn ? source?.name_en : (source?.name_cn || source?.name_en)
}

// export const getCountryImgSrc = (iconName) => {
//   try {
//     return require(`@/assets/images/flag/${iconName?.toLowerCase().trim()}.svg`)
//   } catch (e) {
//     return require('@/assets/images/flag/default.svg')
//   }

// }